<template>
  <ClientChip :client-relation-id="column.id" :data-test="`client-name-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import ClientChip from '@/components/Clients/ClientChip.vue'

// Spreads the chip's fragment so the row query warms the cache the chip reads from.
const ClientNameColumn = graphql(`
  fragment ClientNameColumn on CompanySupplier {
    id
    company {
      id
      name
    }
    ...ClientChip
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientNameColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(ClientNameColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
